import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "23",
  viewBox: "0 0 20 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "10.3004",
      cy: "6.11879",
      r: "4.74965",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M19.1028 22.609V18.4927C19.1028 16.2835 17.3119 14.4927 15.1028 14.4927H10.3033H5.50391C3.29477 14.4927 1.50391 16.2835 1.50391 18.4927V22.609",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }